import { CombinedError } from 'urql'
import combinedErrorToString from './errorParsing'

const throwGQLError = (combinedError: CombinedError): never => {
  throw new Error(`URQL Request Failed!\n${combinedErrorToString(combinedError)}`)
}

export default throwGQLError
